var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-report-grid"},[_c('asc-ag-grid-filter',{key:("asc-report-grid_" + _vm.gridId),attrs:{"grid-options":_vm.agGridOptions,"column-defs":_vm.getGridColumnDefs,"row-data":_vm.agGridRowData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }